import { render } from "./GoodsManagement.vue?vue&type=template&id=f19805e0&scoped=true"
import script from "./GoodsManagement.vue?vue&type=script&lang=js"
export * from "./GoodsManagement.vue?vue&type=script&lang=js"

import "./GoodsManagement.vue?vue&type=style&index=0&id=f19805e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f19805e0"

export default script